<template>
    <div class='demo'>
        <div class="page" style="padding: 20px;" >
            <van-button class="test" type="primary" block >测试弹出框问题1</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题2</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题3</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题4</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题5</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题6</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题7</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题8</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题9</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题10</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题11</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题12</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题13</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题14</van-button>
            <van-button class="test" type="primary" block >测试弹出框问题15</van-button>
            <van-button class="test" type="info" block >测试弹出框问题</van-button>
            <van-button class="test" type="warning" block >-----底部2----</van-button>
            <van-button class="test" type="danger" block >-----底部1----</van-button>
        </div>
        <div ref="botFooter" class="comment_input_box"  v-show="commentPop">
            <!--<form action="#" class="comment_form">-->
            <input :placeholder="commentPlaceholder" @click="bandTextFocus" class="comment_input" v-model="reply_text" ref="content"
                    @keyup.enter="checkReply" @blur="bandTextBlur()"/>
            <!--</form>-->
            
            <div class="comment_input_right" @click="checkReply">
                <span class="iconfont iconsend comment_i" :class="canSend?'comment_i_active':''"></span>
            </div>
        </div>
        <van-popup v-model="show" position="bottom" :style="{ height: '70%' }"  @close="close" @opened="opened">
           <div ref="botFooter" class="comment_input_box2"  >
            <!--<form action="#" class="comment_form">-->
            <input :placeholder="commentPlaceholder" @click="bandTextFocus" class="comment_input" v-model="reply_text" ref="content2"
                    @keyup.enter="checkReply" @blur="bandTextBlur()"/>
            <!--</form>-->
            
            
          </div>
        </van-popup>
    </div>
    
</template>
<script>
import {Image as VanImage,Button,Popup,Divider,Toast ,Checkbox,Icon,ActionSheet,ImagePreview,Dialog,Loading,Swipe, SwipeItem, Field} from 'vant';
import login from '@/components/common/login';
import VConsole from "vconsole";
var vConsole = new VConsole();

export default {
        name: "index",
        components:{
           [Button.name]:Button,
           [Popup.name]:Popup,
           [Field.name]:Field,
        },
        data(){
            return {
                reply_text: "",
                bodyShow: false,
                commentPop: true,
                commentPlaceholder: "发表你的精彩评论~",
                ii: 0,
                canSend: false,//是否可以发送
                show: false,//是否可以发送
            }
        },
        computed: {
          
        },
        watch: {
            //监听输入变化
            reply_text(newV, oldV) {
                console.log(newV)
                newV == '' ? this.canSend = false : this.canSend = true
            }
        },
        created() {
            //this.onPlayerPlay(this.$refs.videoPlayer.player)
        },
        
        mounted() {
           document.body.addEventListener('focusin', () => {  //软键盘弹起事件
              console.log("键盘弹起"); 
               document.body.scrollTop = 10000;
               document.documentElement.scrollTop=10000;
          });
          document.body.addEventListener('focusout', () => { //软键盘关闭事件
              console.log("键盘收起");
          });

          
        },
        methods:{
          close(){
              this.commentPop = true
          },
          bandTextFocus(){
              console.log("聚焦！！！")
              // document.documentElement.scrollTop = 0
              this.show = true
              this.commentPop = false
              
              // this.$refs.botFooter.style.bottom = '110px'
          },
          opened(){
            this.$refs.content2.focus()
            
            // window.scrollTo(0, 0);
          },
          bandTextBlur(){
              console.log("失去焦点")
              // this.$refs.botFooter.style.bottom = '0px'
              //this.reply_type = 1
              //this.reply_text = ""
          },
          checkReply(){
                console.log("1111")
          }
        }
    }

</script>

<style scoped>

.comment_input_box {
  position: fixed;
  bottom:0px;
  /* top:0px; */
  opacity:1;
  z-index: 2999;
  width: 100%;
  border-top: 1px solid #585858;
  background: #1F1F21;
  padding: 10px 15px;
  box-sizing: border-box;
  display: flex;
}
.comment_input{
  flex: 1;
  background: #353539;
  color: #fff;
  border-radius: 16px;
  height: 36px;
  border: none;
  padding-left: 10px;
}
.comment_input_right{
  width: 36px;
  text-align: center;
}
.comment_i{
  font-size: 22px;
  line-height: 36px;
  color: #999;
  transition: .3s;
}
.comment_i_active {
  color: #f44;
}
.comment_input_box2{
  background-color: #1F1F21;
  padding: 10px 15px;
}
</style>